import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PetplanTrialApplication } from 'src/app/interfaces/petplan';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PetplanService {
  constructor(
     private http: HttpClient,
  ) {}

  petplanSave(petId: number) {
    return this.http.post(`${environment.apiUrl}/api/v2/petplan/pet/${petId}/save`, null);
  }

  submitPetplanTrialApplication(petplanApplication: PetplanTrialApplication, petId: number): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/v2/petplan/pet/${petId}/register`,
      petplanApplication
    );
  }

  completePetplanApplication() {
    return this.http.put<any>(`${environment.apiUrl}/api/users/me/welcome-gift-step`, {});
  }
}
